import gql from 'graphql-tag';

const UPDATE_CATEGORIES = gql`
    mutation updateCategories ($params: UpdateCategoriesParams!) {
        updateCategories (params: $params) {
        message,
        status,
        data
        }
    }
`;

export default UPDATE_CATEGORIES;
